"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: 1,
  question: "How does Click Viral help restaurants build their email list?",
  answer: "We use data-driven strategies combined with seamless integration with your reservation and POS systems to capture customer information at key touchpoints. Our team creates compelling opt-in campaigns that turn diners into subscribers, ensuring steady list growth without disrupting your operations."
}, {
  id: 2,
  question: "What kind of results can I expect from email marketing?",
  answer: "Restaurants typically see higher repeat-visit rates, increased direct bookings, and measurable ROI. Our targeted campaigns drive 20-40% more repeat customers on average, with detailed analytics to track every metric that matters to your business."
}, {
  id: 3,
  question: "Do you integrate with existing reservation systems?",
  answer: "Yes, we specialize in seamless integration with popular reservation platforms like OpenTable, Resy, and major POS systems. Our technical team ensures smooth data flow without any disruption to your current operations."
}, {
  id: 4,
  question: "How long does it take to see results?",
  answer: "Most restaurants begin seeing measurable list growth within the first 30 days. Meaningful engagement and ROI typically become apparent within 60-90 days as we optimize campaigns based on your specific audience and brand voice."
}, {
  id: 5,
  question: "What makes Click Viral different from other email marketing agencies?",
  answer: "We focus exclusively on restaurants, understanding the unique challenges of the hospitality industry. Our team knows culinary niches, seasonal trends, and diner behavior patterns. We don't rely on third-party platforms, giving you full ownership of your subscriber list and direct communication with your customers."
}, {
  id: 6,
  question: "How are campaigns personalized for my restaurant?",
  answer: "We start by understanding your brand voice, culinary style, and target audience. Each campaign is custom-crafted with compelling copywriting that reflects your unique identity, ensuring every message resonates with your diners and drives meaningful engagement."
}];
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className={`bg-background py-16 px-4 transition-all duration-[150ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-[10px] opacity-0"}`}>
			<div className="mx-auto max-w-7xl flex flex-col lg:flex-row gap-12 lg:gap-24 items-start">
				<div className="w-full lg:w-1/3 lg:text-left text-center lg:mb-0 mb-12">
					<h2 className="mb-4 font-display text-4xl font-bold text-foreground md:text-5xl">
						Frequently Asked Questions
					</h2>
					<p className="text-muted-foreground text-lg">
						Everything you need to know about building your restaurant's email
						list
					</p>
				</div>

				<div className="w-full flex-1">
					<Accordion type="single" collapsible className="w-full space-y-4">
						{faqs.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className="border-border rounded-lg border px-6 transition-all duration-[120ms] ease-out hover:shadow-soft">
								<AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline">
									{faq.question}
								</AccordionTrigger>
								<AccordionContent className="text-muted-foreground">
									{faq.answer}
								</AccordionContent>
							</AccordionItem>)}
					</Accordion>
				</div>
			</div>
		</section>;
}